import { default as Configs } from "../constants/Configs";

export const BASE_URL = Configs.API_URL;
export const GLOBAL_TOKEN =
  "eyJhbGciOiJIUzUxMiIsImlhdCI6MTU3MzkwMjI0MCwiZXhwIjoxNTczOTAyODQwfQ.eyJpZCI6MX0.OHHQTsLuK7Cy9dsklnp-JumDoJVdBrCUh6j21gr0YWgz3uLkhpmamAKS6vntIh9MTraXcYlItqA_NUFcc4nXMw";
export const MAX_RETRY = 2;
export const RETRY_INTERVAL = 5000;
